// Login Page
// Full-page login experience for existing users

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useUsername } from '../hooks/useUsername';
import LoginModal from '../components/LoginModal/LoginModal';
import UsernameModal from '../components/UsernameModal/UsernameModal';
import './Login.css';

const Login = () => {
  const navigate = useNavigate();
  const { isAuthenticated, login, register } = useUsername();
  // "Sign up" links come here with ?signup=1 and should open account creation,
  // not the log-in form (which answered a new player with "Username not found").
  const [showRegisterModal, setShowRegisterModal] = useState(
    () => new URLSearchParams(window.location.search).has('signup')
  );

  // Redirect if already authenticated
  useEffect(() => {
    if (isAuthenticated) {
      navigate('/profile');
    }
  }, [isAuthenticated, navigate]);

  const handleLogin = async (username, password) => {
    const result = await login(username, password);
    if (result.success) {
      navigate('/profile');
    }
    return result;
  };

  const handleRegister = async (username, password, avatar, email) => {
    const result = await register(username, password, avatar, email);
    if (result.success) {
      setShowRegisterModal(false);
      navigate('/profile');
    } else {
      throw new Error(result.error);
    }
  };

  const handleSwitchToRegister = () => {
    setShowRegisterModal(true);
  };

  const handleBackToLogin = () => {
    setShowRegisterModal(false);
  };

  return (
    <>
    <Helmet>
      <title>Sign In - One Piece Trivia</title>
      <meta name="robots" content="noindex, nofollow" />
    </Helmet>
    <div className="login-page">
      <div className="login-page-background"></div>

      {!showRegisterModal ? (
        <LoginModal
          isOpen={true}
          onLogin={handleLogin}
          onClose={() => navigate('/')}
          onSwitchToRegister={handleSwitchToRegister}
        />
      ) : (
        <UsernameModal
          isOpen={true}
          onSubmit={handleRegister}
          onSkip={handleBackToLogin}
          initialUsername=""
          allowQuickSave={false}
        />
      )}
    </div>
    </>
  );
};

export default Login;
